import { type PersonaAttributes } from './generated/PersonaAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Persona extends PersonaAttributes {}

@model
class Persona extends ApplicationModel {
  static terminologyName = 'Persona';

  // Start auto-generated
  static typename: 'Persona' = 'Persona';
  get typename(): 'Persona' {
    return 'Persona';
  }

  static internalTypename: 'Persona' = 'Persona';
  get internalTypename(): 'Persona' {
    return 'Persona';
  }

  static filterType = 'PersonaFilters!';
  static filters = { id: '[ID!]', projectId: 'ID' };

  static fields = {
    commentsCount: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    comments: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default Persona;
